import {
  ErrorDetailsDtoErrorCodeEnum,
  OnboardingEditVehicleRequest,
  ResponseErrorDto,
} from '@interfaces/models';
import { removeOnboardingImportedVehicle, editOnboardingImportedVehicle } from '@api/onboarding';
import { useMutation } from '@tanstack/react-query';

export const useOnboardingImportedVehicles = ({
  onRemoveVehicleSuccess,
  onEditVehicleSuccess,
  onRemoveVehicleError,
  onEditVehicleError,
}: {
  onRemoveVehicleError?: (error: ErrorDetailsDtoErrorCodeEnum) => void;
  onEditVehicleError?: (error: ErrorDetailsDtoErrorCodeEnum) => void;
  onRemoveVehicleSuccess?: () => void;
  onEditVehicleSuccess?: () => void;
}) => {
  const { mutate: removeVehicle, isPending: isRemoveVehiclePending } = useMutation({
    mutationFn: (vehicleId: string) => removeOnboardingImportedVehicle(vehicleId),
    onSuccess: () => {
      onRemoveVehicleSuccess?.();
    },
    onError: ({ error }: { error: ResponseErrorDto }) => {
      onRemoveVehicleError?.(error.errorCode as ErrorDetailsDtoErrorCodeEnum);
    },
  });

  const { mutate: editVehicle, isPending: isEditVehiclePending } = useMutation({
    mutationFn: ({
      vehicle,
      vehicleId,
    }: {
      vehicle: OnboardingEditVehicleRequest;
      vehicleId: string;
    }) => editOnboardingImportedVehicle(vehicle, vehicleId),
    onSuccess: () => {
      onEditVehicleSuccess?.();
    },
    onError: ({ error }: { error: ResponseErrorDto }) => {
      onEditVehicleError?.(error.errorCode as ErrorDetailsDtoErrorCodeEnum);
    },
  });

  return { removeVehicle, editVehicle, isRemoveVehiclePending, isEditVehiclePending };
};
